<template>
    <div id="Sigin">
        <div class="layout-content-wrap">
            <img src="@/assets/maoz/new2/Group 947.png" alt="">
      <img src="@/assets/maoz/new2/Group 850.png" alt="">
      <img src="@/assets/maoz/new2/Group 849.png" alt="">
       <img src="@/assets/maoz/new2/Group 848.png" alt="">
        </div>
    </div>
</template>
  

<script>
import { ActSignin, SetSignin, SigninAward, ActConsume,ConsumeAward } from '@/network/api.js'
import {
    mapState,
    mapMutations
} from 'vuex'

export default {
    name: 'Sigin',
    data() {
        return {
            show: false,    //展示获得的奖励
            ItemArr: [],//中奖数据

            actSiginData: {
                sunday: 0,   //星期天
                monday: 0,    //星期一
                tuesday: 0,
                wednesday: 0,
                thursday: 0,
                friday: 0,
                saturday: 0,
                integral: 0,     //积分
                patch_up: 0,     //可用补签次数
                red_envelope: 0,    ///红包状态0:初始状态1:可领取2:已领取状态
            },
            ///消耗活动数据
            actConsumeData: {
                quota: 0, ///每天消费c币
                awards: [],
            }

        }
    },

    created() {
        //this.GetActSignin();
        //this.GetActConsume();
    },
    activated () {
        this.GetActSignin();
        this.GetActConsume();
     },
    filters: {
        LvGuoLv(val) {
            if (val == '1') {
                return 'lv1'
            } else if (val == '2') {
                return 'lv2'
            } else if (val == '3') {
                return 'lv3'
            } else if (val == '4') {
                return 'lv4'
            } else if (val == '5') {
                return 'lv5'
            }
        },
    },

    methods: {
        ///签到点击
        SiginClick() {
            let week = new Date().getDay();
            if (week == 0) {
                week = 7;///星期天参数需要7
            }

            SetSignin(week).then((res) => {
                this.actSiginData = res.data.data;
                this.$message({
                    message: '签到成功',
                    type: 'success'
                })
            })
        },

        //积分开启宝箱
        OpenSiginBox(boxId) {
            //254  随机红包
            //255  随机狙击枪 
            //248  随机音乐盒 
            //249  随机探员 
            //250  随机步枪 
            //251  白银宝箱 
            //252  黄金宝箱 
            //253  钻石宝箱 
            SigninAward(boxId).then((res) => {
                //console.log(res.data.data);
                this.actSiginData = res.data.data.signinData;
                ///弹出奖励
                this.show = true;
                this.ItemArr = res.data.data.awardlist;



            })
        },
        CloseShowAward(){
            this.show = false;
            this.ItemArr=[];
        },

        GetStatusImage(s) {
            if (s == 0) {
                return require('@/assets/images/Sigin/sig01.png');
            }
            return require('@/assets/images/Sigin/sig02.png');
        },

        ///获取签到活动数据
        GetActSignin() {
            ActSignin().then((res) => {
                this.actSiginData = res.data.data;
            })
        },

        ///消费活动数据
        GetActConsume() {
            ActConsume().then((res) => {
                this.actConsumeData = res.data.data;
            })
        },  

        ///领取消费活动的奖励
        GetConsumeAward(boxId){
            // 256 消耗200C币 
            // 257 消耗500C币 
            // 258 消耗1000C币 
            // 259 消耗2000C币 
            // 260 消耗5000C币 
            // 261 消耗10000C币 
            // 262 消耗20000C币 
            ConsumeAward(boxId).then((res) => {
                ///弹出奖励
                this.show = true;
                this.ItemArr = res.data.data.awardlist;
            })

        },


        ...mapMutations([
            'User'
        ])

    },
    computed: {
        ...mapState([
            'user'
        ])
    }
}
</script>
  
<style lang="scss">
.layout-content-wrap {
    user-select: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #061242;

    .act_sigin {
        margin-top: 10px;
        .title {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 398px;
                height: 114px;
            }
        }

        //补签次数
        .patch_up {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 6px;
            p {
                color: #8b8c97;
                font-size: 14px;
            }

        }

        //签到区
        .sigin_list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 14px;

            .item-ul {
                display: flex;

                .item-ul-li {
                    display: flex;
                    align-items: center;

                    .info {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin: 0px 10px;

                        .sig-img {
                            img {
                                width: 130px;
                                height: 110px;
                            }
                        }

                        .sig-txt {
                            font-size: 14px;
                            color: #8b8c97;
                            line-height: 1;
                            margin-top: 5px;
                        }

                    }
                }
            }

        }

        //签到按钮
        .sigin_btn {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 40px;

            .btn {
                width: 280px;
                height: 100%;
            }

        }

        ///查看记录
        .sigin_record {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .record {
                font-size: 15px;
                font-weight: 600;
            }

            .integral {
                font-size: 15px;
                font-weight: 600;
            }
        }

        ///三个宝箱
        .sigin_box_list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .box_item_ul {
                display: flex;

                .box_item_ul_li {
                    display: flex;
                    align-items: center;

                    .info {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin: 0px 40px;

                        .box_img {
                            img {
                                width: 260px;
                                height: 180px;
                            }
                        }

                        .box_name {
                            margin-top: 20px;

                            img {
                                width: 140px;
                                height: 40px;
                            }
                        }

                        .box_btn {
                            margin-top: 10px;
                            width: 180px;
                            height: 44px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: url(../../assets/images/Sigin/red_envelope_btn.png) no-repeat center;
                            background-size: 100% 100%;

                            p {
                                font-size: 16px;
                                font-weight: 600;
                            }

                        }

                    }
                }
            }

        }

        ///积分兑换奖励
        .integral_award_list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 40px;

            .integral_item_ul {
                display: flex;

                .integral_item_ul_li {
                    display: flex;
                    align-items: center;

                    .integral_info {
                        width: 180px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin: 0px 10px;
                        background: url(../../assets/images/Sigin/integral_award_bg.png) no-repeat center;
                        background-size: 100% 100%;

                        ///红包用的
                        .integral_red_envelope {
                            width: 140px;
                            height: 26px;
                            margin-top: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: url(../../assets/images/Sigin/red_envelope_title.png) no-repeat center;
                            background-size: 100% 100%;

                            p {
                                font-size: 10px;
                            }

                        }

                        .integral_null {
                            width: 140px;
                            height: 26px;
                            margin-top: 10px;
                        }

                        ///积分兑换图片
                        .integral_img {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            img {
                                width: 90%;
                                height: 100%;
                            }
                        }

                        .integral_name {
                            font-size: 15px;
                            font-weight: 600;
                        }

                        ///需要积分数量
                        .integral_num {
                            margin: 3px 0px;
                            color: #ffd300;
                            font-size: 13px;
                        }

                        ///积分兑换---红包领取
                        .red_envelope_btn {
                            width: 116px;
                            height: 33px;
                            margin-bottom: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: url(../../assets/images/Sigin/red_envelope_btn.png) no-repeat center;
                            background-size: 100% 100%;

                            p {
                                font-size: 14px;
                                font-weight: 600;
                            }
                        }

                        .exchange_btn {
                            width: 116px;
                            height: 33px;
                            margin-bottom: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: url(../../assets/images/Sigin/exchange_btn.png) no-repeat center;
                            background-size: 100% 100%;

                            p {
                                font-size: 14px;
                                font-weight: 600;
                            }
                        }


                    }
                }
            }

        }

        ///活动规则
        .act_rule {
            width: 100%;
            height: 60px;
            margin-top: 30px;
            display: flex;
            //justify-content: center;
            align-items: center;
            background: url(../../assets/images/Sigin/act_rule.png) no-repeat center;
            background-size: 100% 100%;

            p{
                margin: 0px 20px;
            }
        }

    }

    ///消费活动
    .act_consume {
        width: 100%;
        margin-top: 50px;

        .title {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 398px;
                height: 114px;
            }

        }

        ///活动规则
        .desc {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            align-items: center;

            p {
                font-size: 17px;
                font-weight: 600;
            }

        }

        ///活动宝箱
        .consume_award_list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;

            .consume_item_ul {
                display: flex;

                .consume_item_ul_li {
                    display: flex;
                    align-items: center;

                    .consume_info {
                        width: 230px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        background: url(../../assets/images/Sigin/consume_award_bg.png) no-repeat center;
                        background-size: 100% 100%;
                        margin: 0px 10px;

                        ///消费活动标题
                        .consume_info_title {
                            width: 160px;
                            height: 26px;
                            margin-top: 10px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background: url(../../assets/images/Sigin/red_envelope_title.png) no-repeat center;
                            background-size: 100% 100%;

                            p {
                                font-size: 10px;
                                font-weight: 600;
                            }

                        }

                        ///消费活动奖励的物品
                        .consume_info_item_list {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .consume_info_item {
                                width: 110px;
                                height: 130px;
                                display: flex;
                                flex-direction: column;
                                align-items: center;

                                .consume_info_item_img {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    img {
                                        width: 90px;
                                        height: 80px;
                                    }
                                }

                                .consume_info_item_name {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    margin: 2px 6px;

                                    p {
                                        font-size: 14px;
                                    }
                                }
                            }
                        }

                        ///领取按钮
                        .consume_info_item_btn {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 110px;
                            height: 33px;
                            margin-bottom: 12px;
                            background: url(../../assets/images/Sigin/exchange_btn.png) no-repeat center;
                            background-size: 100% 100%;

                            p {
                                font-size: 14px;
                                font-weight: 600;
                            }

                        }


                    }
                }
            }
        }

        ///查看记录
        .consume_record {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 200px;

            .consume_bean {
                p {
                    font-size: 15px;
                    font-weight: 600;
                }
            }

            .award_record {
                p {
                    font-size: 15px;
                    font-weight: 600;
                }
            }
        }
    }

}

.wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .Show_box {
        width: 100%;
        box-sizing: border-box;
        border-radius: 4px;
        position: relative;
        text-align: center;

        .Show_list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .Show_item {
                width: 200px;
                text-align: center;
                background: url(../../assets/images/Roll/LV1.png) no-repeat center;
                background-size: 100% 100%;
                border-radius: 4px;
                border: 1px solid #E9B10E;
                &.lv1 {
                    background: url(../../assets/images/Roll/LV1.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv2 {
                    background: url(../../assets/images/Roll/LV2.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv3 {
                    background: url(../../assets/images/Roll/LV2.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv4 {
                    background: url(../../assets/images/Roll/LV3.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv5 {
                    background: url(../../assets/images/Roll/LV3.png) no-repeat center;
                    background-size: 100% 100%;
                }

                .info {
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 10px;

                    .jiage {
                        height: 100%;
                        display: flex;
                        align-items: center;

                        img {
                            width: 20px;
                            height: 20px;
                            vertical-align: middle;
                        }

                        p {
                            font-size: 14px;
                            color: #5AE9D3;
                        }
                    }

                    .kucun {
                        font-size: 14px;
                        color: #808FA4;
                    }
                }

                .pic {
                    width: 170px;
                    height: 150px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-size: cover;
                    position: relative;
                    z-index: 1;

                    img {
                        vertical-align: middle;
                        max-width: 100%;
                        max-height: 100%;
                    }
                }

                .item-data {
                    width: 100%;
                    padding: 5px;
                    box-sizing: border-box;
                    text-align: center;

                    .name {
                        margin-bottom: 6px;
                        font-size: 14px;
                        color: #fff;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                }
            }

        }

    }
}</style>
  